<template>
  <div>
    <template v-if="info !== null">
      <h4>Создание отчетов</h4>
      <p class="mb-2">
        Запрос на создание отчетов: {{reportsRebuildRequestedStr}}<br>
        Статус процесса: {{isStatBuildingStr}}
      </p>

      <b-button v-if="mayManageM3Stat && !info.reportsRebuildRequested" @click="requestTotalRebuild">Создать запрос</b-button>
      <b-button v-if="mayManageM3Stat && info.reportsRebuildRequested"  @click="delTotalRebuildRequest">Удалить запрос</b-button>
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
/**
 * @typedef { import('../../auth.js').Actor } Actor
 */
import auth from '../../auth.js';

import { HTTP } from '../../http-common.js';

import { mayManageM3Stat as utilMayManageM3Stat } from '../../model/m3level.js';

import notifier from '../../notifier.js';
import LoadingIndicator from '../LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ReportsBuildingPanel',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      /** @type {?Actor} */
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,

      /** @type {?StatManagerInfo} */
      info: null,

      updateTimeoutId: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    reportsRebuildRequestedStr() {
      const info = this.info;
      if(info === null) {
        return null;
      }

      if(info.reportsRebuildRequested) {
        return 'запрос существует';
      } else {
        return 'нет запроса';
      }
    },

    /** @returns {?string} */
    isStatBuildingStr() {
      const info = this.info;
      if(info === null) {
        return null;
      }

      if(info.isStatBuilding) {
        return 'отчеты создаются';
      } else {
        return 'отчеты не создаются';
      }
    },

    /** @returns {boolean} */
    mayManageM3Stat() {
      const actor = this.actor;
      if(actor === null) {
        return false;
      }

      return utilMayManageM3Stat(actor.role);
    },
  },

  created() {
    this.loadManagerInfo();
  },

  beforeDestroy() {
    this.clearUpdateTimeout();
  },

  methods: {
    loadManagerInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = '/m3/manager_info';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          this.loadState = LOAD_STATE_LOADED_ERROR;
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.info = data;

        this.loadState = LOAD_STATE_LOADED_NORMAL;

        this.createUpdateTimeout();
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    requestTotalRebuild() {
      HTTP.post('/m3/request_total_rebuild')
      .then(() => {
        const info = this.info;
        if(info === null) {
          return;
        }

        notifier.showSuccess('Запрос создан.');
        info.reportsRebuildRequested = true;
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    delTotalRebuildRequest() {
      HTTP.post('/m3/del_total_rebuild_request')
      .then(() => {
        const info = this.info;
        if(info === null) {
          return;
        }

        notifier.showSuccess('Запрос удален.');
        info.reportsRebuildRequested = false;
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },

    createUpdateTimeout() {
      this.clearUpdateTimeout();

      const UPDATE_DELAY_MSEC = 1000;
      this.updateTimeoutId = setTimeout(this.handleUpdateTime, UPDATE_DELAY_MSEC);
    },

    clearUpdateTimeout() {
      if(this.updateTimeoutId !== null) {
        clearTimeout(this.updateTimeoutId);
        this.updateTimeoutId = null;
      }
    },

    handleUpdateTime() {
      this.clearUpdateTimeout();
      this.loadManagerInfo();
    },
  },
};

/**
 * @typedef {Object} StatManagerInfo
 * @property {boolean} reportsRebuildRequested
 * @property {boolean} isStatBuilding
 */
</script>
